module.exports = __webpack_public_path__ + "static/img/411_phase_function_Paper_PointsHejduk_Prediction.430434e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/411_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cC0V
// module chunks = 0